import { Component, Input } from '@angular/core';
import { NotificationModel } from '@evorait/pace-core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-object-info',
    templateUrl: './object-info.component.html',
    styleUrls: ['./object-info.component.scss'],
    standalone: false,
})
export class ObjectInfoComponent {
    @Input()
    public notification: NotificationModel;
    public constructor(public readonly modalInstance: BsModalRef) {}
}
